<bt-loader [loaderId]="loaderId">
  <div class="flex column full-height">
    <div [id]="overflowDiv"
         class="flex-1 padding-left-small padding-right overflow margin-bottom margin-top">
         @if((comments.data?.length / comments.size) === (comments.page + 1)){
           <div class="flex center hover"
                (click)="getComments(comments.page + 1)">
             <div class="line flex-1"></div>
             <div class="text padding primary">Load more</div>
             <div class="line flex-1"></div>
           </div>
         }
      @for(item of comments.data; track item){
        <div class="card margin-top-small margin-bottom relative"
             [ngClass]="{'margin-right-large': !item.isMine, 'margin-left-large primary': item.isMine}">
          <div class="flex margin-bottom-small"
               [ngClass]="{'justify-end': !item.isMine}">
            {{item.creationDate | date: 'MM/dd/yy, hh:mm:ss a'}}
          </div>
          <div class="flex"
               [ngClass]="{'center': !!item.imgPath, 'row-reverse': !!item.imgPath && item.isMine}">
               @if(!!item.imgPath){
                 <div class="thumbnail"
                      [ngClass]="{'margin-right': !item.isMine, 'margin-left': item.isMine}">
                   <div class="img-container">
                     <img [preview]="'shot'"
                          [src]="item.imgPath">
                   </div>
                 </div>
               }
            <div class="flex-1"
                 [ngClass]="{'text-right': item.isMine}">{{item.comments}}</div>
          </div>
        </div>
      }
    </div>
    <div class="flex-0">
      <div class="margin-bottom-small">
        <textarea rows="4"
                  placeholder="Type message..."
                  class="full-width"
                  cols="50"
                  style="resize: none;"
                  [(ngModel)]="message"></textarea>
      </div>
      <button class="full-width"
              [disabled]="!comments.data"
              (click)="onSendMessage()">
        <i class="fa fa-send"></i>Post comment
      </button>
    </div>
  </div>
</bt-loader>
